import {
  Swiper, EffectFade, Navigation, Lazy, Pagination,
} from 'swiper';

const swiperContainerClass = '.hero__container';

function initHero(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    loop: true,
    preloadImages: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 15000,
      disableOnInteraction: false,
    },
    modules: [EffectFade, Navigation, Lazy, Pagination],
    lazy: true,
    pagination: {
      clickable: true,
      el: '.hero__pagination',
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=hero-slider', ($block) => {
      initHero($block.find(swiperContainerClass)[0]);
    });
  } else {
    initHero(swiperContainerClass);
  }
});
